import React, {useState,useEffect } from "react";
import "./HeaderComponent.css";
import navliks from "./NavbarLinks.json";
import logo from "./logo.png";
import HamburgerButton from "../../fragments/hamburgher-button/HamburgerButton";
import { Link} from "react-router-dom";

export default function HeaderComponent({items}) {
  const [isOpen, setIsOpen] = useState(false);


  const handleMenuToggle = (isOpen) => {
    setIsOpen(isOpen); // Imposta lo stato del menu
  };

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    // Cleanup quando il componente viene smontato
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  return (
    <div className="header-container">
      <div className={`header-overlay ${isOpen ? "menu-open" : ""} `}></div>
      <HamburgerButton isOpen={isOpen} onClick={() => handleMenuToggle(!isOpen)}/>
      <ul className={`navbar-links ${isOpen ? "open" : "close"}`}>
        <span className="init-margin"/>
        {items.map((item) => {
          const linkData = navliks.find((link) => link.id === item);
          return linkData ? (
          <li className="navbar-element neomorphism-button " key={item}>
            <Link to={linkData.path} onClick={() => handleMenuToggle(!isOpen)}>
              {linkData.value}
            </Link>
          </li>
          ) : null;
        })}
        <div className="logo">
          <Link to="/" onClick={() => handleMenuToggle(!isOpen)}>
            <img src={logo} width="90" height="100" alt="Logo" />
          </Link>
        </div>
         
      
      </ul>
    </div>
  );
}
